import React from "react";
import { Field, ConfigInput } from "./Field";

export function LawRulerFields({ config, setConfig }) {
  return (
    <>
      <Field label="Endpoint URL" required colSpan={2}>
        <ConfigInput name="endpoint" config={config} setConfig={setConfig}
          testId="dest-endpoint" required className="text-xs"
          placeholder="From Law Ruler > Setup > 3rd Party Integrations" />
      </Field>
      <Field label="API key" required>
        <ConfigInput name="api_key" config={config} setConfig={setConfig}
          testId="dest-api-key" required type="password"
          placeholder="Sent as `Key` in the payload body" />
      </Field>
      <Field label="Lead provider (optional)">
        <ConfigInput name="lead_provider" config={config} setConfig={setConfig}
          placeholder="LeadFlow (default)" mono={false} />
      </Field>
      <Field label="Content type" colSpan={2}>
        <select className="w-full border border-black px-2 py-1.5 mt-1 font-mono text-xs"
          value={config.content_type || ""}
          onChange={(e) => setConfig("content_type", e.target.value)}>
          <option value="">application/json (default)</option>
          <option value="application/x-www-form-urlencoded">application/x-www-form-urlencoded</option>
        </select>
      </Field>
    </>
  );
}

export function LeadDocketFields({ config, setConfig }) {
  return (
    <>
      <Field label="Endpoint URL" required colSpan={2}
        hint="Find under Manage › Integrations › Definitions. No API key needed for the inbound form endpoint.">
        <ConfigInput name="endpoint" config={config} setConfig={setConfig}
          testId="dest-endpoint" required className="text-xs"
          placeholder="https://<firmname>.leaddocket.com/Opportunities/Form/<id>" />
      </Field>
      <Field label="Content type" colSpan={2}>
        <select className="w-full border border-black px-2 py-1.5 mt-1 font-mono text-xs"
          value={config.content_type || ""}
          onChange={(e) => setConfig("content_type", e.target.value)}>
          <option value="">application/x-www-form-urlencoded (default)</option>
          <option value="application/json">application/json</option>
        </select>
      </Field>
    </>
  );
}
